export const defaultConfig = {
  testModeEnabled: /^.*\.test\..*$/.test(window.location.hostname),
  customOneSdkVersionEnabled: false,
  oneSdkVersion: '',
  customOnfidoSdkVersionEnabled: false,
  onfidoSdkVersion: '14.54.0',
  idvVendorDebugMode: false,
  sentryEnabled: false,
  sentryReplaysEnabled: false,
  env: 'local',
  sentryDsn: '',
  apiBaseUrl: '',
  immersveApiBaseUrlTest: '',
  immersveApiBaseUrlLive: '',
  clientApplicationIdTest: '',
  clientApplicationIdLive: '',
  googleApiKey: '',
  tokenExpiryBufferMs: 60000 * 5, // 5 minutes
  logoOverrideUrl: '',
  axiosTimeout: 12000, // matching up with Amethyst
  errorPartnerNameOverride: '',
  sumsubIdvRedirectEnabled: true,
  mixpanelEnabled: false,
  mixpanelTokenLive: '',
  mixpanelTokenTest: '',
  fakeIdvEnabled: false,
  completeKycSessionEnabled: true,
  googlePlacesApiNewEnabled: false,
};

export const readOnlyConfigKeys = ['testModeEnabled'];

export type AppConfigSchema = typeof defaultConfig;
